import { Injectable } from '@angular/core';
import { DriverTask } from '../classes/driver-task';
import { Events } from '../classes/events';
import { SAVED_STARTED_TASKS_KEY } from '../common/constants';

export interface CurrentTaskCounts{
  currentUnassignedTaskCount: number,
  currentDriverTaskCount: number
}
@Injectable({
  providedIn: 'root'
})
export class ProcessDataService {

  constructor() { }

  currentUnassignedTaskCount = 0;
  currentDriverTaskCount = 0;


  processData(data: Events, manualOrAuto: string): CurrentTaskCounts{

    if(manualOrAuto === 'full'){
      this.currentUnassignedTaskCount = data.unassignedTasks.length;
      this.currentDriverTaskCount = data.driverTasks.length;
    }else{
      const unassignedTaskStatus = data['unassignedTaskStatus'];
      const driverTaskStatus = data['driverTaskStatus'];

      switch (unassignedTaskStatus) {
        case "none":
          this.currentUnassignedTaskCount = 0;
          break;
        case "updated":
          this.currentUnassignedTaskCount = data.unassignedTasks.length;
          break;
        default:
          break;
      }

      switch (driverTaskStatus) {
        case "none":
          this.currentDriverTaskCount = 0;
          this.saveCurrentTasksToLocalStorage(data.driverTasks);
          break;
        case "updated":
          this.currentDriverTaskCount = data.driverTasks.length;
          this.saveCurrentTasksToLocalStorage(data.driverTasks);
          break;
        default:
          break;
      }
    }
    return {
      currentUnassignedTaskCount: this.currentUnassignedTaskCount,
      currentDriverTaskCount: this.currentDriverTaskCount
    };
  }

  saveCurrentTasksToLocalStorage(driverTasks: Array<DriverTask>): void{
    let tasks = [];
    tasks = driverTasks.map(({taskName}) => [taskName]);
    localStorage.setItem(SAVED_STARTED_TASKS_KEY, JSON.stringify(tasks))
  }

}
